import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectsFetchFailedAction = {
	type: 'SUBJECTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectsFetchFailedAction => ({
	type: 'SUBJECTS_FETCH_FAILED',
	payload,
});
